<template>
  <div>
    <v-img
      v-if="image.type == 'image'"
      style="position: absolute"
      :src="image.image"
      height="100%"
      width="100%"
      contain
      >
      <template v-slot:placeholder>
        <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>
    <pdf v-else-if="image.type == 'pdf'"
      :src="image.image"
      class="center"
      />
    <div
      v-else class="other-file-type"
    >
      <v-icon
        :size="30"
        >
        insert_drive_file
      </v-icon>
      {{image.extension}} <br>
      {{$t('Project.Workpackage.Images.FormatError')}}
    </div>
  </div>
</template>
<script>
import pdf from 'vue-pdf'
export default {
  components: {
    pdf
  },
  props: [
    'image'
  ],
}
</script>
<style>
.center {
  margin: auto;
  width: 50%;
  padding: 10px;
}
.other-file-type {
  text-align: center;
  color: white;
}
</style>
